import { render, staticRenderFns } from "./MsgDetailList.vue?vue&type=template&id=375616eb&"
import script from "./MsgDetailList.vue?vue&type=script&lang=js&"
export * from "./MsgDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports